import { render, staticRenderFns } from "./OuttriperPhoto.vue?vue&type=template&id=579cbb38&scoped=true&"
import script from "./OuttriperPhoto.vue?vue&type=script&lang=js&"
export * from "./OuttriperPhoto.vue?vue&type=script&lang=js&"
import style0 from "./OuttriperPhoto.vue?vue&type=style&index=0&id=579cbb38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579cbb38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
